module.exports = __webpack_public_path__ + "static/3-038e07d291c2c57ef0fbbbfa06d43938.jpg";